import React, { useState, useEffect } from 'react'
import { 
    Toast, 
    ToastHeader, 
    ToastBody, 
} from 'reactstrap';
import { sprintf } from 'sprintf-js';

const NotificationBagde = ({ notification, onBadgeClick }) => {
    const [show, setShow] = useState(true);
    const [toggled, setToggled] = useState(false);
    let timeout = null;


    if(show) {
        timeout = setTimeout(() => {
            toggle()
        }, 3000)
    }

    const toggle = () => {
        setShow(!show);
    }

    const onToastClick = () => {
        if(!toggled) {
            onBadgeClick(notification)
        }
    }

    useEffect( () => {
        const toggleButton = document.querySelector("#notificationBadge_"+notification.id+" .toast-header button");
        if(toggleButton) {
            toggleButton.addEventListener("mouseover", (event) => {
                setToggled(true);
            })
            toggleButton.addEventListener("mouseout", (event) => {
                setToggled(false);
            })
        }

        return () => {
            if(timeout) {
                clearTimeout(timeout);
            }
        }
    })

    // console.log('NotificationBadge', notification)
    return ( (notification !== null && (!notification.silent) ) 
        ? ( <Toast isOpen={ show } fade={ true } style={{cursor: "pointer"}} id={"notificationBadge_"+notification.id} onClick={onToastClick}>
                <ToastHeader>{ notification.title }</ToastHeader>
                <ToastBody>
                    { sprintf(notification.body, notification.count_with_tag) }
                </ToastBody>
            </Toast> ) 
        : <></>
    )
}
export default NotificationBagde;